import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    width: '100%'
  },
  // display: block restores normal inline flow around the inline <strong> (a documented Label gotcha
  // in staff-fe/AGENTS.md) so the space after the colon is preserved.
  text: {
    display: 'block',
    padding: theme.spacing(1, 0)
  },
  removeButton: {
    flexShrink: 0
  }
}));

export default useStyles;
